import { callService } from '@api/caller';
import { TURKEY_ID } from '@constants/constants';

interface ICountry {
  cCode: string;
  id: number;
  code?: string | undefined;
  name?: string | undefined;
}

const reorderTurkeyFromCountries = (countries: ICountry[]) => {
  const TURKEY_INDEX = countries.findIndex((c) => c.code === TURKEY_ID);
  if (TURKEY_INDEX !== -1) {
    countries.unshift(countries.splice(TURKEY_INDEX, 1)[0]);
  }
  return countries;
};

const fetchCountries = async (): Promise<ICountry[]> => {
  const [countries, countriesWithCode] = await Promise.all([
    callService('LocationsService', 'listCountries'),
    callService('LocationsService', 'listCountriesWithCode'),
  ]);

  const CountryNameCodeMap = countriesWithCode.reduce((acc, c) => {
    acc[c.name as string] = c.code as string;
    return acc;
  }, {} as { [name: string]: string });

  const preparedCountries = countries.map((c) => ({
    ...c,
    cCode: CountryNameCodeMap[c.name as string],
    id: +(c.code ?? 0),
  }));

  return reorderTurkeyFromCountries(preparedCountries);
};

export default fetchCountries;
